import { Link, styled } from '@mui/material'

export const DelegatesLink = styled(Link)`
  text-decoration: none;
`
